export type ProviderId = 'google' | 'apple' | 'telegram';

/**
 * The provider marks, drawn.
 *
 * These were strings: 'G' for Google, '✈️' for Telegram, and **'' for Apple** —
 * an empty string, so the Apple button shipped with an empty circle where its
 * logo should be. Nothing failed; a blank is a perfectly valid string.
 *
 * Drawn monochrome in `currentColor` rather than in each brand's colours, for
 * the same reason the game draws its own icons: three full-colour logos on a
 * near-black cave palette read as three foreign objects, and an OS emoji is
 * whatever font the device happens to ship. These sit in the same visual
 * language as the rest of the screen and recolour with it.
 */
export function ProviderMark({ id }: { id: ProviderId }) {
  if (id === 'apple') {
    return (
      <svg viewBox="0 0 24 24" width={15} height={15} fill="currentColor" aria-hidden>
        <path d="M16.4 12.6c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.1-2.8.9-3.5.9s-1.8-.9-3-.8c-1.5 0-2.9.9-3.7 2.2-1.6 2.7-.4 6.8 1.1 9 .8 1.1 1.7 2.3 2.9 2.2 1.2 0 1.6-.7 3-.7s1.8.7 3 .7c1.3 0 2.1-1.1 2.8-2.2.9-1.2 1.3-2.4 1.3-2.5 0 0-2.5-1-2.5-3.5z" />
        <path d="M14.2 5.6c.6-.8 1.1-1.9 1-3-.9 0-2.1.6-2.8 1.4-.6.7-1.1 1.8-1 2.9 1 .1 2.1-.5 2.8-1.3z" />
      </svg>
    );
  }
  if (id === 'telegram') {
    return (
      <svg viewBox="0 0 24 24" width={15} height={15} fill="currentColor" aria-hidden>
        <path d="M21.6 3.7 2.9 10.9c-.9.3-.9 1.6.1 1.8l4.7 1.2 1.8 5.5c.2.7 1.1.9 1.6.3l2.5-2.7 4.6 3.4c.6.4 1.4.1 1.6-.6l3-14.6c.2-.9-.7-1.7-1.6-1.4zM9.4 14.1l8.4-5.9-6.7 6.9-.3 3z" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" width={15} height={15} fill="currentColor" aria-hidden>
      <path d="M12 10.9v2.6h4.3c-.2 1.1-1.4 3.3-4.3 3.3-2.6 0-4.7-2.1-4.7-4.8S9.4 7.2 12 7.2c1.5 0 2.5.6 3 1.2l2-2C15.7 5.2 14 4.5 12 4.5 7.9 4.5 4.6 7.8 4.6 12s3.3 7.5 7.4 7.5c4.3 0 7.1-3 7.1-7.2 0-.5 0-.9-.1-1.3H12z" />
    </svg>
  );
}
